import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import clsx from 'clsx';
import { useState } from 'react';
import EmbedLayout from '@/components/widget/Layout';
import { Loader } from '@/components/loaders/Modal';
import useWidgetConfig, { useReportingWidgetConfig } from '@/hooks/useWidgetConfig';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var CircularDesign = function CircularDesign(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("circle", {
      cx: "190",
      cy: "204",
      r: "173",
      fill: "#E3EAFD"
    }), /*#__PURE__*/_jsx("circle", {
      cx: "213.5",
      cy: "353.5",
      r: "50.5",
      fill: "#3E66EF"
    }), /*#__PURE__*/_jsx("circle", {
      cx: "33",
      cy: "281",
      r: "32",
      stroke: "#004DE6",
      strokeWidth: "2"
    }), /*#__PURE__*/_jsxs("g", {
      filter: "url(#filter0_d_3882_23058)",
      children: [/*#__PURE__*/_jsx("circle", {
        cx: "338.5",
        cy: "113.5",
        r: "82.5",
        fill: "white"
      }), /*#__PURE__*/_jsx("circle", {
        cx: "338.5",
        cy: "113.5",
        r: "77",
        stroke: "#004DE6",
        strokeWidth: "11"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsxs("filter", {
        id: "filter0_d_3882_23058",
        x: "225",
        y: "0",
        width: "225",
        height: "225",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dx: "-1",
          dy: "-1"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "15"
        }), /*#__PURE__*/_jsx("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_3882_23058"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "effect1_dropShadow_3882_23058",
          result: "shape"
        })]
      })
    })]
  }));
};

CircularDesign.defaultProps = {
  width: "450",
  height: "404",
  viewBox: "0 0 450 404",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

const PrimaryWidget = _ref => {
  let {
    widgetId,
    elementId,
    name,
    advertisement = true,
    onLoad
  } = _ref;
  const {
    0: isReady,
    1: setIsReady
  } = useState(false); // Load target widget

  const {
    status: widgetConfigStatus,
    data: widget,
    error: widgetConfigError
  } = useWidgetConfig(widgetId); // Load reporting widget

  const {
    status: reportingWidgetStatus,
    data: reportingWidget,
    error: reportingWidgetError
  } = useReportingWidgetConfig(widget);
  const isLoaded = widgetConfigStatus === 'success' && reportingWidgetStatus === 'success';
  const hasError = widgetConfigError || reportingWidgetError;
  return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({
    className: styles.container
  }, elementId && {
    id: elementId
  }), {}, {
    children: [/*#__PURE__*/_jsx("div", {
      className: clsx(styles.main, name ? styles[`-${name}`] : '', !isReady ? styles['-heightControl'] : ''),
      children: !hasError && isLoaded && widget && reportingWidget ? /*#__PURE__*/_jsx(EmbedLayout, {
        className: styles.widget,
        widgetId: widget.id || '',
        reportingWidgetId: reportingWidget.id,
        elementId: widget.elementId,
        config: widget.config,
        sections: widget.sections || {},
        subscriptionActive: widget.subscriptionActive,
        onLoad: () => {
          setIsReady(true);
          onLoad && onLoad();
        }
      }) : /*#__PURE__*/_jsx("div", {
        className: styles.main__loader,
        children: /*#__PURE__*/_jsx(Loader, {
          title: "Loading Calculator"
        })
      })
    }), advertisement && /*#__PURE__*/_jsx("aside", {
      className: styles.advertisement
    }), /*#__PURE__*/_jsx(CircularDesign, {
      className: styles.container__circularDesign
    })]
  }));
};

export default PrimaryWidget;